import React, { useState } from "react";
import "../../../styles/TimeAndSeat.scss";

interface Ticket {
  id: string;
  ticket_type: string;
  price: string;
  available_slot: string;
  ticket_count?: number;
  capacity?: number;
}

interface Props {
  tickets: Ticket[];
  availableDates: string[];
  isSeatSection?: boolean;
  onDateSelect: (date: string) => void;
  onTimeSelect: (time: string) => void;
  onTicketSelect: (ticketType: string) => void;
  onSeatSelect?: (seatIds: string[]) => void;
}

const TimeAndSeat: React.FC<Props> = ({
  tickets,
  availableDates,
  isSeatSection = false,
  onDateSelect,
  onTimeSelect,
  onTicketSelect,
  onSeatSelect,
}) => {
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [selectedTime, setSelectedTime] = useState<string | null>(null);
  const [selectedTicket, setSelectedTicket] = useState<string | null>(null);
  const [selectedSeats, setSelectedSeats] = useState<string[]>([]);

  const handleDateSelect = (date: string) => {
    setSelectedDate(date);
    setSelectedTime(null);
    setSelectedTicket(null);
    setSelectedSeats([]);
    onDateSelect(date);
    onSeatSelect?.([]);
  };

  const handleTimeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const time = e.target.value;
    setSelectedTime(time);
    setSelectedTicket(null);
    setSelectedSeats([]);
    onTimeSelect(time);
    onSeatSelect?.([]);
  };

  const handleTicketChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const ticketType = e.target.value;
    setSelectedTicket(ticketType);
    onTicketSelect(ticketType);
  };

  const handleSeatClick = (ticket: Ticket) => {
    const isUnavailable = Number(ticket.ticket_count || 0) >= Number(ticket.capacity || 0);

    if (isUnavailable) return;

    setSelectedSeats((prev) => {
      const exists = prev.includes(ticket.id);

      const updated = exists
        ? prev.filter((id) => id !== ticket.id)
        : [...prev, ticket.id];

      onSeatSelect?.(updated);

      const selectedNames = tickets
        .filter((t) => updated.includes(t.id))
        .map((t) => t.ticket_type)
        .join(", ");

      onTicketSelect(selectedNames);

      return updated;
    });
  };

  const getTimesForDate = () => {
    if (!selectedDate) return [];

    return availableDates
      .filter(
        (d) =>
          new Date(d).toDateString() === new Date(selectedDate).toDateString()
      )
      .map((d) =>
        new Date(d).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
  };

  return (
    <div className="time-seat-section">
      <h3>Select Date</h3>

      <div className="calendar-container">
        {availableDates.map((date) => {
          const formatted = new Date(date).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            weekday: "short",
          });

          return (
            <div
              key={date}
              className={`calendar-date ${selectedDate === date ? "selected" : ""}`}
              onClick={() => handleDateSelect(date)}
            >
              {formatted}
            </div>
          );
        })}
      </div>

      {selectedDate && (
        <>
          <h3>Select Time</h3>

          <select value={selectedTime || ""} onChange={handleTimeChange}>
            <option value="" disabled>
              Select time
            </option>

            {getTimesForDate().map((time, index) => (
              <option key={index} value={time}>
                {time}
              </option>
            ))}
          </select>
        </>
      )}

      {selectedDate && selectedTime && (
        <>
          <h3>{isSeatSection ? "Select Seat/s" : "Select Ticket Type"}</h3>

          {isSeatSection ? (
            <div className="seat-grid">
              {tickets.map((ticket) => {
                const isUnavailable =
                  Number(ticket.available_slot || 0) >= Number(ticket.available_slot || 0);

                const isSelected = selectedSeats.includes(ticket.id);

                return (
                  <button
                    key={ticket.id}
                    type="button"
                    disabled={isUnavailable}
                    className={`seat-btn ${isSelected ? "selected" : ""} ${
                      isUnavailable ? "unavailable" : ""
                    }`}
                    onClick={() => handleSeatClick(ticket)}
                  >
                    {ticket.ticket_type}
                  </button>
                );
              })}
            </div>
          ) : (
            <select value={selectedTicket || ""} onChange={handleTicketChange}>
              <option value="" disabled>
                Select ticket type
              </option>

              {tickets.map((ticket) => (
                <option key={ticket.id} value={ticket.ticket_type}>
                  {ticket.ticket_type} - ₱
                  {parseFloat(ticket.price).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}{" "}
                  ({ticket.available_slot} Slot
                  {Number(ticket.available_slot) > 1 ? "s" : ""} Available)
                </option>
              ))}
            </select>
          )}
        </>
      )}
    </div>
  );
};

export default TimeAndSeat;


// import React, { useState } from "react";
// import "../../../styles/TimeAndSeat.scss";

// interface Seat {
//   seat_number: string;
//   is_available: boolean;
// }

// interface Ticket {
//   ticket_type: string;
//   available_time: string;
//   available_slot: string;
//   price: string;
//   seats?: Seat[];
// }

// interface Props {
//   tickets: Ticket[];
//   availableDates: string[];
//   onDateSelect: (date: string) => void;
//   onTimeSelect: (time: string) => void;
//   onTicketSelect: (ticketType: string) => void;
// }

// const TimeAndSeat: React.FC<Props> = ({
//   tickets,
//   availableDates,
//   onDateSelect,
//   onTimeSelect,
//   onTicketSelect,
// }) => {
//   const [selectedDate, setSelectedDate] = useState<string | null>(null);
//   const [selectedTime, setSelectedTime] = useState<string | null>(null);
//   const [selectedTicket, setSelectedTicket] = useState<string | null>(null);

//   const handleDateSelect = (date: string) => {
//     setSelectedDate(date);
//     setSelectedTime(null);
//     setSelectedTicket(null);
//     onDateSelect(date);
//   };

//   const handleTimeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     const time = e.target.value;
//     setSelectedTime(time);
//     setSelectedTicket(null);
//     onTimeSelect(time);
//   };

//   const handleTicketChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     const ticketType = e.target.value;
//     setSelectedTicket(ticketType);
//     onTicketSelect(ticketType);
//   };

//   const getTimesForDate = () => {
//     if (!selectedDate) return [];
//     return availableDates
//       .filter(
//         (d) =>
//           new Date(d).toDateString() === new Date(selectedDate).toDateString()
//       )
//       .map((d) =>
//         new Date(d).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
//       );
//   };

//   return (
//     <div className="time-seat-section">
//       <h3>Select Date</h3>
//       <div className="calendar-container">
//         {availableDates.map((date) => {
//           const formatted = new Date(date).toLocaleDateString("en-US", {
//             month: "short",
//             day: "numeric",
//             weekday: "short",
//           });

//           return (
//             <div
//               key={date}
//               className={`calendar-date ${
//                 selectedDate === date ? "selected" : ""
//               }`}
//               onClick={() => handleDateSelect(date)}
//             >
//               {formatted}
//             </div>
//           );
//         })}
//       </div>

//       {selectedDate && (
//         <>
//           <h3>Select Time</h3>
//           <select value={selectedTime || ""} onChange={handleTimeChange}>
//             <option value="" disabled>
//               Select time
//             </option>
//             {getTimesForDate().map((time, index) => (
//               <option key={index} value={time}>
//                 {time}
//               </option>
//             ))}
//           </select>
//         </>
//       )}

//       {selectedDate && selectedTime && (
//         <>
//           <h3>Select Ticket Type</h3>
//           <select value={selectedTicket || ""} onChange={handleTicketChange}>
//             <option value="" disabled>
//               Select ticket type
//             </option>
//             {tickets.map((ticket, index) => (
//               <option key={index} value={ticket.ticket_type}>
//                 {ticket.ticket_type} - ₱
//                 {parseFloat(ticket.price).toLocaleString(undefined, {
//                   minimumFractionDigits: 2,
//                 })}{" "}
//                 ({ticket.available_slot} Slot
//                 {Number(ticket.available_slot) > 1 ? "s" : ""} Available)
//               </option>
//             ))}
//           </select>
//         </>
//       )}
//     </div>
//   );
// };

// export default TimeAndSeat;